module.exports = __webpack_public_path__ + "img/202412_firstserum_voice.0b822775.jpg";